var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 8H1.5V0.875C1.5 0.6875 1.3125 0.5 1.125 0.5H0.375C0.164062 0.5 0 0.6875 0 0.875V8.75C0 9.17188 0.328125 9.5 0.75 9.5H11.625C11.8125 9.5 12 9.33594 12 9.125V8.375C12 8.1875 11.8125 8 11.625 8ZM10.875 1.25H8.08594C7.59375 1.25 7.33594 1.85938 7.6875 2.21094L8.46094 2.98438L6.75 4.69531L5.01562 2.98438C4.73438 2.67969 4.24219 2.67969 3.96094 2.98438L2.34375 4.60156C2.20312 4.74219 2.20312 4.97656 2.34375 5.11719L2.88281 5.65625C3.02344 5.79688 3.25781 5.79688 3.39844 5.65625L4.5 4.57812L6.21094 6.28906C6.49219 6.59375 6.98438 6.59375 7.26562 6.28906L9.51562 4.03906L10.2891 4.8125C10.6406 5.16406 11.2266 4.90625 11.2266 4.41406V1.625C11.25 1.4375 11.0625 1.25 10.875 1.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLine);
export default __webpack_public_path__ + "static/media/chart-line.1a4a3d5047b144448ef1489ad0dc76a0.svg";
export { ForwardRef as ReactComponent };